import { STAT, URLVER } from './config';
const { homeAll, homeRecommend, kline, stock, rank } = STAT;

window?.weblog?.setConfig({
  appKey: 'ce19ea099b',
});

export function statClick(statId: string, logmap?: Object) {
  window?.weblog?.report({
    id: statId,
    action: 'click',
    logmap,
  });
}

export function statShow(statId: string, logmap?: Object) {
  window.weblog.report({
    id: statId,
    action: 'show',
    logmap,
  });
}

// 分时页面
export const klinePage = () => window.hxmPageStat(kline, URLVER);
// 评级变动提醒-滑动
export const klinePjbdSlip = () => window.hxmClickStat(`${kline}.pjbd.slip`, URLVER);
// 评级变动提醒-点击
export const klinePjbdClick = () => window.hxmClickStat(`${kline}.pjbd.click`, URLVER);
// 观点统计-机构评级-切换进入tab
export const klineGdtjGrade = () => window.hxmClickStat(`${kline}.gdtj.grade`, URLVER);
// 观点统计-目标价格-切换进入tab
export const klineTarget = () => window.hxmClickStat(`${kline}.gdtj.target`, URLVER);
// 观点统计-目标价格-组件交互（点击/滑动）
export const klineTargetClick = () => window.hxmClickStat(`${kline}.gdtj.target.click`, URLVER);
// 观点统计-净利润预测-切换进入tab
export const klineForecast = () => window.hxmClickStat(`${kline}.gdtj.forecast`, URLVER);
// 观点统计-净利润预测-组件交互（点击）
export const klineForecastClick = () => window.hxmClickStat(`${kline}.gdtj.forecast.click`, URLVER);
// 评级买入排名点击
export const klineMrpm = () => window.hxmClickStat(`${kline}.mrpm`, URLVER);
// 评级上调排名点击
export const klineStpm = () => window.hxmClickStat(`${kline}.stpm`, URLVER);
// 目标价格上涨空间排名点击
export const klineSzkj = () => window.hxmClickStat(`${kline}.szkj`, URLVER);
// 研报学院专题点击
export const klineYbxy = () => window.hxmClickStat(`${kline}.ybxy`, URLVER);
// 研报学院课程点击
export const klineYhyb = () => window.hxmClickStat(`${kline}.yhyb`, URLVER);
// 关闭研报学院运营位
export const klineXtzClose = () => window.hxmClickStat(`${kline}.yytj.close`, URLVER);

// 个股变动提醒
export const stockBdtx = () => window.hxmClickStat(`${stock}.bdtx`, URLVER);
// 个股上涨潜力
export const stockSzql = () => window.hxmClickStat(`${stock}.szql`, URLVER);
// 个股机构评级tab点击
export const stockJgpj = () => window.hxmClickStat(`${stock}.jgpj`, URLVER);
// 个股目标价格tab点击
export const stockMbjg = () => window.hxmClickStat(`${stock}.mbjg`, URLVER);
// 个股净利润预测tab点击
export const stockJlrjc = () => window.hxmClickStat(`${stock}.jlrjc`, URLVER);
// 评级买入排名点击
export const stockMrpm = () => window.hxmClickStat(`${stock}.mrpm`, URLVER);
// 评级上调排名点击
export const stockStpm = () => window.hxmClickStat(`${stock}.stpm`, URLVER);
// 目标价格上涨空间排名点击
export const stockSzkj = () => window.hxmClickStat(`${stock}.szkj`, URLVER);
// 研报学院专题点击
export const stockYbxy = () => window.hxmClickStat(`${stock}.ybxy`, URLVER);
// 研报学院课程点击
export const stockYhyb = () => window.hxmClickStat(`${stock}.yhyb`, URLVER);
// 关闭研报学院运营位
export const stockXtzClose = () => window.hxmClickStat(`${stock}.yytj.close`, URLVER);

// 首页全部tab 研报类型选择
export const homeAllYblx = () => window.hxmClickStat(`${homeAll}.yblx`, URLVER);
// 首页全部tab 行业类型选择
export const homeAllHyfl = () => window.hxmClickStat(`${homeAll}.hyfl`, URLVER);
// 首页全部tab 机构/分析师选择
export const homeAllJgfxs = () => window.hxmClickStat(`${homeAll}.jgfxs`, URLVER);
// 首页全部tab 评级选择
export const homeAllPj = () => window.hxmClickStat(`${homeAll}.pj`, URLVER);
// 首页全部tab 只看深度
export const homeAllOnsd = () => window.hxmClickStat(`${homeAll}.onsd`, URLVER);
// 首页全部tab 不看深度
export const homeAllOffsd = () => window.hxmClickStat(`${homeAll}.offsd`, URLVER);
// 首页全部tab 不看图表
export const homeAllOfftb = () => window.hxmClickStat(`${homeAll}.offtb`, URLVER);
// 首页全部tab 看图表
export const homeAllOntb = () => window.hxmClickStat(`${homeAll}.ontb`, URLVER);

// 查看头像
export const homeAllFxszy = () => window.hxmClickStat(`${homeAll}.fxszy`, URLVER);
// 查看查看第二头部
export const homeAllJgzy = () => window.hxmClickStat(`${homeAll}.jgzy`, URLVER);
// 关注
export const homeAllGuanzhu = () => window.hxmClickStat(`${homeAll}.guanzhu`, URLVER);
// 不关注
export const homeAllJianGuanzhu = () => window.hxmClickStat(`${homeAll}.jianguanzhu`, URLVER);
// 查看研报 点击标题
export const homeAllTitle = () => window.hxmClickStat(`${homeAll}.title`, URLVER);
// 查看研报 点击查看研报
export const homeAllChakan = () => window.hxmClickStat(`${homeAll}.chakan`, URLVER);
// 去分时
export const homeAllGgfs = () => window.hxmClickStat(`${homeAll}.ggfs`, URLVER);

// 推荐更多
export const homeRecommendPaihang = () => window.hxmClickStat(`${homeRecommend}.paihang`, URLVER);

// 推研报学院更多
export const homeRecommendZhuanti = () => window.hxmClickStat(`${homeRecommend}.xtzzt`, URLVER);
// 推荐研报学院课程
export const homeRecommendKecheng = () => window.hxmClickStat(`${homeRecommend}.xtzkc`, URLVER);

// 排行榜 上涨空间 筛选
export const rankShaixuan = () => window.hxmClickStat(`${rank}.shaixuan`, URLVER);
